module.exports = __webpack_public_path__ + "static/media/5_8.7053bccd.png";